export const redirectActions = {
    connectNearWallet: 'connectNearWallet',
    createMultisafe: 'createMultisafe',
    batchRequest: 'batchRequest',
    batchConfirm: 'batchConfirm'
};
